export default __webpack_public_path__ + "static/media/slide-4.22be1345.webp";